<template>
    <w-alerts :items="formErrorAlerts"></w-alerts>
</template>

<script>
    import WFormErrorAlertsMixin from '../../mixins/forms/w-form-error-alerts-mixin'
    import WAlerts from '../WAlerts'

    /**
     * A component which uses WAlerts to format form errors
     */
    export default {
        name: 'WCardFormErrorAlerts',
        mixins: [WFormErrorAlertsMixin],
        components: {
            WAlerts
        }
    }
</script>
